var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 24.5,
    cy: 45.5,
    rx: 6,
    ry: 1.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9935 24.2502L10.9935 24.2502C10.9979 20.6693 12.4223 17.2362 14.9544 14.7042C17.4864 12.1721 20.9193 10.7477 24.5001 10.7433C28.0809 10.7477 31.5138 12.1721 34.0459 14.7042C36.578 17.2362 38.0024 20.6693 38.0068 24.2502V24.2502C38.0111 27.1747 37.0559 30.0198 35.2878 32.3492L35.2811 32.3581L35.2793 32.3609L35.2699 32.3732L35.2267 32.4299L35.0919 32.6063C34.9897 32.7398 34.8871 32.8729 34.8625 32.9027C34.8623 32.9029 34.8621 32.9031 34.8619 32.9034L24.5001 45.1235L14.1419 32.9077C14.1418 32.9076 14.1418 32.9075 14.1417 32.9075C14.116 32.8769 14.0123 32.7425 13.9088 32.6074C13.8583 32.5415 13.8096 32.4777 13.7736 32.4305L13.7304 32.3738L13.7184 32.3581L13.7153 32.3539L13.7145 32.3529L13.7144 32.3527L13.7143 32.3526L13.7143 32.3526C11.9451 30.0223 10.9893 27.176 10.9935 24.2502ZM29.7435 24.2502V24.2499C29.7435 23.2128 29.436 22.1991 28.8599 21.3368C28.2837 20.4745 27.4648 19.8025 26.5067 19.4056C25.5486 19.0088 24.4943 18.9049 23.4772 19.1072C22.4601 19.3096 21.5258 19.8089 20.7925 20.5422C20.0592 21.2755 19.5598 22.2098 19.3575 23.2269C19.1552 24.2441 19.259 25.2983 19.6559 26.2564C20.0527 27.2145 20.7248 28.0334 21.5871 28.6096C22.4493 29.1857 23.4631 29.4933 24.5001 29.4933L24.5004 29.4933C25.8905 29.4917 27.2232 28.9388 28.2061 27.9559C29.1891 26.9729 29.742 25.6402 29.7435 24.2502Z",
    fill: "white",
    stroke: "#450A0A",
    strokeWidth: 0.486773
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedMapMarker);
export default __webpack_public_path__ + "static/media/selected-map-marker.6672cedf3515e360945a717cfa974938.svg";
export { ForwardRef as ReactComponent };